module.exports = __webpack_public_path__ + "static/media/6a.a531fe93.png";